import { AcessibilityPage as Acessibility } from "./acessibility.page";
export default Acessibility;
